import { Alert } from '@creditornot/cb-alert';
import { Typography } from '@creditornot/cb-ingredients';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { InsightsReportType } from 'apis/merchant-gateway/insights';
import { telemetryBusinessInsightsV2ReportBuilderChooseReportType } from 'modules/insights-v2/telemetry';

import CustomSelect from '../core/CustomSelect';
import ReportFormItem from '../core/ReportFormItem';
import { InsightReportForm } from '../types';

const StyledRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  padding-block-start: 4px;
  margin-block-end: 8px;
`;

export const insightsReportTypeOptions: { [key in InsightsReportType]: string } = {
  [InsightsReportType.PERFORMANCE]: 'insights.reports.report-type.options.performance',
  [InsightsReportType.OPERATIONS]: 'insights.reports.report-type.options.operations',
  [InsightsReportType.RATINGS]: 'insights.reports.report-type.options.ratings',
  [InsightsReportType.SETTLEMENTS]: 'insights.reports.report-type.options.settlements',
  [InsightsReportType.MOST_SOLD_ITEMS]: 'insights.reports.report-type.options.most-sold-items',
};
export const InsightsReportTypeFormItem = ({
  onChange,
  supportedReportTypes,
}: {
  supportedReportTypes: InsightsReportType[];
  onChange?: (reportType: InsightsReportType) => void;
}) => {
  const { formatMessage } = useIntl();
  const insightsReportForm = useForm<InsightReportForm>();
  const insightsReportFormState = insightsReportForm.getState();

  return (
    <ReportFormItem
      title={<FormattedMessage id="insights.reports.report-type.question" />}
      value={
        <>
          <StyledRadioGroup>
            {supportedReportTypes.map(reportType => (
              <Field<InsightReportForm['reportType']>
                name="reportType"
                type="radio"
                value={reportType}
                key={reportType}
              >
                {({ input }) => (
                  <CustomSelect
                    {...input}
                    onChange={() => {
                      input.onChange(input.value);
                      onChange?.(input.value);
                      telemetryBusinessInsightsV2ReportBuilderChooseReportType(input.value);
                    }}
                  >
                    <Typography.Body3>
                      {insightsReportTypeOptions[reportType] ? (
                        <FormattedMessage id={insightsReportTypeOptions[reportType]} />
                      ) : (
                        <FormattedMessage id="insights.unknown" />
                      )}
                    </Typography.Body3>
                  </CustomSelect>
                )}
              </Field>
            ))}
          </StyledRadioGroup>
          {insightsReportFormState.submitFailed && insightsReportFormState.errors?.reportType && (
            <Alert variant="error" size="small">
              {formatMessage({ id: insightsReportFormState.errors.reportType.id })}
            </Alert>
          )}
        </>
      }
    />
  );
};
